import { useState } from "react";
import user from "../../assets/blog/user.svg"
import mobile from "../../assets/blog/mobile.svg"
import mail from "../../assets/blog/mail.svg"
import indflag from "../../assets/blog/indflag.svg"

export default function ScheduleSession() {
    const [custName, setName] = useState("");
    const [custMob, setCustMob] = useState(Number);
    const [email, setEmail] = useState("");
    return(
        <section className="w-full mx-auto sm:w-[80%]">
            <div className="bg-primary-color w-full text-xl mb-9 sm:text-3xl rounded-lg py-6 px-6 text-white flex flex-col gap-2 text-center">
                <p className="text-xl sm:text-3xl">
                    Stay Updated with the <span className="text-secondary-color">Latest Insights</span>
                </p>
                <div className="flex w-full md:w-2/3 md:mx-auto px-2 justify-center py-4 gap-4 text-[14px]sm:text-lg">
                    <input 
                        className="px-4 w-full rounded-lg py-2 bg-transparent placeholder-white text-white border border-white"
                        type="text" 
                        placeholder="Email Address"
                        value={email || ""}
                        onChange={(e)=>setEmail(e.target.value)}
                    />
                    <button
                        type="button"
                        className="bg-white px-6 py-2 rounded-lg text-primary-color font-medium	"
                    >
                        Subscribe
                    </button>
                </div>
                <p className="text-[13 px] sm:text-base">
                    Stay curious, stay informed, and stay ahead. Subscribe to our blog today!
                </p>
            </div>
            <div className="text-center py-4">
                <p className="text-primary-color font-semibold text-2xl sm:text-3xl">
                    Schedule 1:1
                </p>
                <p className="text-secondary-color font-semibold text-2xl sm:text-3xl">
                    Counseling Session Today!
                </p>
                
                <form className="w-full flex text-[13 px] sm:text-base flex-col justify-center items-center gap-5 mt-12 rounded-lg py-4 px-4 bg-gradient-to-r from-[#FF99000D] to-[#04236B0D] ">
                    <p className="text-black">
                        Add details to get a call back
                    </p>

                    <div className="flex w-full justify-center gap-4">
                        <div className="p-2 shadow-custom bg-white rounded-lg">
                            <img src={user} alt="usericon" className="w-5 h-5" />
                        </div>
                        <input
                            className="px-4 md:px-8 w-full md:w-1/2 py-2 shadow-custom bg-white rounded-lg"
                            type="text"
                            value={custName || ""}
                            onChange={(e)=>setName(e.target.value)}
                            placeholder="Name"
                        />
                    </div>
                    <div  className="flex w-full justify-center gap-4">
                        <div className="p-2 shadow-custom bg-white rounded-lg">
                            <img src={mobile} alt="mobileicon" className="w-5 h-5" />
                        </div>
                        <div className="flex relative gap-5 w-full md:w-1/2 rounded-lg shadow-custom bg-white overflow-hidden ">
                            <div className="flex left-4 pr-4 absolute items-center py-0.5 my-1.5 justify-center gap-2 border-r border-[#999999]">
                                <img src={indflag} alt="indflag" className="w-5 h-5" />
                                <p>
                                    +91
                                </p>
                            </div>
                            <input 
                                className="pl-28 w-full focus:rounded-lg focus:border-[#999999] bg-white"
                                type="tel"
                                value={custMob || ""}
                                onChange={(e)=>setCustMob(e.target.value)}
                                placeholder="Phone Number"
                            />

                        </div>
                    </div>
                    <div  className="flex w-full justify-center gap-4">
                        <div className="p-2 shadow-custom bg-white rounded-lg">
                            <img src={mail} alt="mailicon" className="w-5 h-5" />
                        </div>
                        <input
                            className="px-4 w-full md:px-8 md:w-1/2 py-2 shadow-custom bg-white rounded-lg"
                            type="email"
                            value={email || ""}
                            onChange={(e)=>setEmail(e.target.value)}
                            placeholder="Email Address"
                        />

                    </div>

                    <button 
                        type="submit"
                        className="bg-primary-color w-fit text-white rounded-lg px-4 py-2"
                    >
                        Request a Call Back
                    </button>
                </form>
            </div>
        </section>
    )
}